import { render, staticRenderFns } from "./loginHeader.vue?vue&type=template&id=09633f76&scoped=true&"
import script from "./loginHeader.vue?vue&type=script&lang=js&"
export * from "./loginHeader.vue?vue&type=script&lang=js&"
import style0 from "./loginHeader.vue?vue&type=style&index=0&id=09633f76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09633f76",
  null
  
)

export default component.exports